import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * `/` — the app root. Everyone lands on their personal landing
 * (`/my`), admins / accountants included — the Analytics dashboard
 * is still reachable via the sidebar, just isn't the default
 * anymore.
 */
export const Route = createFileRoute("/_app/")({
  beforeLoad: () => {
    throw redirect({ to: "/my" });
  },
});
